import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import * as React from 'react'

import { cn } from '@/lib/utils'

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'w-[18px] h-[18px] shrink-0 rounded-[4px] data-[state=checked]:bg-primary disabled:border-text-disabled disabled:cursor-not-allowed data-[state=checked]:disabled:bg-text-disabled data-[state=checked]:border-none border border-[#CCCCCC] bg-transparent flex items-center justify-center text-white',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn('flex items-center justify-center text-primary')}
    >
      <svg
        width="14"
        height="10"
        viewBox="0 0 14 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.62445 5.50452L4.57683 8.4734C4.65593 8.55524 4.75166 8.61753 4.85706 8.65574C4.96247 8.69394 5.07489 8.70711 5.18617 8.69427C5.29837 8.68293 5.40709 8.64653 5.50494 8.58756C5.6028 8.52859 5.68749 8.44843 5.75325 8.35253L12.6492 1.08787"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
